<template>
  <div class="status-label">{{ trans("live.auction_states.before_start.title") }}</div>
  <div class="auction-live-date">{{ liveStartFormatted }}</div>
  <timer-live
    :class="{ warning: timerDays < 1 }"
    :data-days="timerDays"
    :data-hours="timerHours"
    :data-minutes="timerMinutes"
    :data-seconds="timerSeconds"
    :data-countdown="true"
  ></timer-live>
</template>

<script setup lang="ts">
  import { trans } from "@/utils/trans";
  import TimerLive from "@/components/_partials/TimerLive.vue";
  import { computed, ref, watch } from "vue";
  import moment from "moment-timezone";
  import { useAuctionStore } from "@/stores/AuctionStore";

  const auctionStore = useAuctionStore();
  const auction = computed(() => auctionStore.auction);

  const timerTotalSeconds = ref<number>(0);
  const start = auction.value?.live_auction_start ? moment(auction.value.live_auction_start) : null;
  const diffSec = start ? start.diff(moment(), "seconds") : 0;
  timerTotalSeconds.value = Math.max(0, diffSec);
  const timerDays = computed(() => Math.floor(timerTotalSeconds.value / (24 * 60 * 60)));
  const timerHours = computed(() => Math.floor((timerTotalSeconds.value % (24 * 60 * 60)) / (60 * 60)));
  const timerMinutes = computed(() => Math.floor((timerTotalSeconds.value % (60 * 60)) / 60));
  const timerSeconds = computed(() => timerTotalSeconds.value % 60);

  const liveStartFormatted = computed(() => {
    const start = auction.value?.live_auction_start ? moment(auction.value.live_auction_start) : null;
    return start ? start.format("MMMM D, hh:mm A z") : "";
  });

  watch(
    () => auction.value?.live_auction_start,
    () => {
      const start = auction.value?.live_auction_start ? moment(auction.value.live_auction_start) : null;
      const diffSec = start ? start.diff(moment(), "seconds") : 0;
      timerTotalSeconds.value = Math.max(0, diffSec);
    },
    { immediate: true }
  );
</script>